import React from 'react';
import { Plus } from 'lucide-react';

const DashboardHeader = ({ user, onCreateRequest }) => {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Service Provider Dashboard
          </h1>
          <p className="text-gray-600">
            Welcome back, {user?.company || user?.name || 'Service Provider'}
          </p>
        </div>
        <button
          onClick={onCreateRequest}
          className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
        >
          <Plus className="h-5 w-5" />
          Create Service Request
        </button>
      </div>
    </div>
  );
};

export default DashboardHeader;
